<template>
  <div class="card-shipping-wise card-dashboard-wise">
    <h4>Atualizar Dados</h4>
    <h6 :class="['m-b-0', 'sub-title-wise', 'text-c-info']">
      Atualize os dados da Dashboard
    </h6>
    <div class="button-container">
      <button class="btn btn-sm btn-info" @click="updateUserData">
        Atualizar
      </button>
    </div>
    <Loading
      v-if="showLoadingModalWise"
      :isLoading="isLoadingModalWise"
      @close="showLoadingModalWise = false"
      :message="'KAKAK'"
    />

    <!-- MODAL -->
    <div v-if="isModalOpen" class="modal-overlay" @click="closeModal">
      <div class="modal-container" @click.stop>
        <div class="modal-header">
          <div>
            <font-awesome-icon
              :icon="['fas', 'paper-plane']"
              class="f-20 text-info"
            />
          </div>
          <div>
            <h4 class="m-b-6">Envio de Boletos e Notificações</h4>
          </div>
          <button @click="isModalOpen = false" class="btn">
            <font-awesome-icon :icon="['fas', 'xmark']" />
          </button>
        </div>

        <div class="modal-content">
          <div class="select-container">
            <label for="shipping-type">Selecione o tipo de envio:</label>
            <select id="shipping-type" v-model="selectedShippingType">
              <option disabled value="">Selecione...</option>
              <option
                v-for="shipping in shippingType"
                :key="shipping.id"
                :value="shipping"
              >
                {{ shipping.name }}
              </option>
            </select>

            <div v-if="Object.keys(selectedShippingType).length">
              <shipping-billets
                v-if="selectedShippingType.name === 'Envio de Boletos'"
                :express-statuses="expressStatuses"
                :express-regional="expressRegional"
                :express-associate="expressAssociate"
                :express-billet-situation="expressBilletSituation"
                :user-message="userMessage"
                :user-data="userData"
                :close-modal="closeModal"
              />
              <shipping-misceallaneous
                v-if="
                  selectedShippingType.name === 'Aniversariantes' ||
                    selectedShippingType.name === 'Boas Vindas'
                "
                :user-message="userMessage"
                :user-data="userData"
                :close-modal="closeModal"
                :miscellaneous-type="selectedShippingType.name"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import shippingBillets from './modal-select/shippingBillets.vue';
import shippingMisceallaneous from './modal-select/shippingMisceallaneous.vue';
import Loading from '../../../components/Loading.vue';
export default {
  components: { shippingBillets, shippingMisceallaneous, Loading },
  data() {
    return {
      isModalOpen: false,
      selectedShippingType: {},
      showLoadingModalWise: false,
      isLoadingModalWise: false,
    };
  },
  computed: {
    ...mapGetters({
      expressStatuses: 'getExpressStatuses',
      expressRegional: 'getExpressRegional',
      expressAssociate: 'getExpressAssociate',
      expressBilletSituation: 'getExpressBilletSituation',
      userMessage: 'getUserMessage',
      userData: 'getUserData',
    }),
    shippingType() {
      if (
        !this.expressStatuses ||
        Object.keys(this.expressStatuses).length === 0
      ) {
        return [];
      }

      return [
        { name: 'Envio de Boletos', statuses: this.expressStatuses || [] },
        { name: 'Aniversariantes' },
        { name: 'Boas Vindas' },
        { name: 'Toda a Base' },
      ];
    },
  },
  methods: {
    ...mapActions(['updateDashboardData']),
    closeModal() {
      this.selectedShippingType = {};
      this.isModalOpen = false;
    },
    async updateUserData() {
      this.showLoadingModalWise = true;
      this.isLoadingModalWise = true;
      await this.updateDashboardData();
      this.isLoadingModalWise = false;
      this.showLoadingModalWise = false;
    },
  },
};
</script>

<style scoped>
.button-container {
  display: flex;
  justify-content: space-around;
}

a {
  font-size: 13px;
  color: #37474f;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-outf;
}
.card {
  border-radius: 5px;
  -webkit-box-shadow: 0 0 5px 0 rgba(43, 43, 43, 0.1),
    0 11px 6px -7px rgba(43, 43, 43, 0.1);
  box-shadow: 0 0 5px 0 rgba(43, 43, 43, 0.1),
    0 11px 6px -7px rgba(43, 43, 43, 0.1);
  border: none;
  margin-bottom: 30px;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}
.card .card-header {
  background-color: transparent;
  border-bottom: none;
  padding: 20px;
  position: relative;
}

.card .card-header.borderless {
  border-bottom: 0 solid transparent;
}

.card .card-header.borderless + .card-block,
.card .card-header.borderless + .card-block-big,
.card .card-header.borderless + .card-block-small {
  padding-top: 0;
}

h4,
h2,
h6,
h3 {
  padding: 0;
  margin: 0;
  font-weight: 400;
  font-size: 16px;
}
h2 {
  font-size: 26px;
  font-weight: bold;
}
h6 {
  font-size: 13px;
}
.page-header {
  margin: 0 50px;
}
.page-header-title {
  display: flex;
  flex-direction: column;
  padding: 40px 20px;
  font-size: 26px;
  font-weight: 400;
  margin-bottom: 30px;
  background: #019ead;
  color: #fff;
}
.page-header-title span {
  font-size: 13px;
}
.sub-title-wise {
  border-bottom: 1px solid rgba(204, 204, 204, 0.35);
  padding-bottom: 10px;
  margin-bottom: 20px;
  font-size: 14px;
  font-weight: 400;
  color: #2c3e50;
}
.card-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  padding: 20px;
  margin: 20px auto;
}
.card-dashboard {
  padding: 40px;
  background-color: white;
  margin: 0;
  flex: 0 0 calc((100% - 40px) / 3);
  max-width: calc((100% - 40px) / 3);
}
.card-header {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}
.card-type {
  padding: 15px 0;
}
.form-group {
  margin-bottom: 15px;
}
.form-control {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 5px;
}
.addFlowWise {
  display: flex;
  justify-content: center;
}
.saveFlowWise {
  padding: 10px;
  display: flex;
  justify-content: flex-start;
}
.btn {
  border-radius: 2px;
  text-transform: capitalize;
  font-size: 15px;
  padding: 0.625rem 1.1875rem;
  cursor: pointer;
  border: transparent;
}
.btn-info {
  background-color: #00bcd4;
  border-color: #00bcd4;
  color: #fff;
  cursor: pointer;
  -webkit-transition: all ease-in 0.3s;
  transition: all ease-in 0.3s;
}
.btn-info:hover {
  background-color: #08e3ff;
  border-color: #08e3ff;
}
.btn-info:active {
  background-color: #008697;
  border-color: #008697;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
}
.btn-info:focus {
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
  background-color: #08e3ff;
}
.btn-info.disabled {
  background-color: rgba(0, 188, 212, 0.5);
  border-color: rgba(0, 188, 212, 0.5);
}

.btn-danger {
  background-color: #ff5370;
  border-color: #ff5370;
  color: #fff;
  cursor: pointer;
  -webkit-transition: all ease-in 0.3s;
  transition: all ease-in 0.3s;
}

.btn-danger:hover {
  background-color: #ff869a;
  border-color: #ff869a;
}

.btn-danger:active {
  background-color: #ff163d;
  border-color: #ff163d;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
}

.btn-danger:focus {
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
  background-color: #ff869a;
}

.btn-danger.disabled {
  background-color: rgba(255, 83, 112, 0.5);
  border-color: rgba(255, 83, 112, 0.5);
}

.btn-success {
  background-color: #2ed8b6;
  border-color: #2ed8b6;
  color: #fff;
  cursor: pointer;
  -webkit-transition: all ease-in 0.3s;
  transition: all ease-in 0.3s;
}

.btn-success:hover {
  background-color: #59e0c5;
  border-color: #59e0c5;
}

.btn-success:active {
  background-color: #20a98e;
  border-color: #20a98e;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
}

.btn-success:focus {
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
  background-color: #59e0c5;
}

.btn-success.disabled {
  background-color: rgba(46, 216, 182, 0.5);
  border-color: rgba(46, 216, 182, 0.5);
}

.bg-c-red {
  background: #ff5370;
}
.text-c-red {
  color: #ff5370;
}
.bg-c-green {
  background: #2ed8b6;
}
.text-c-green {
  color: #2ed8b6;
}
.bg-c-yellow {
  background: #ffb64d;
}
.text-c-yellow {
  color: #ffb64d;
}
.m-b-5 {
  margin-bottom: 5px;
}
.m-b-0 {
  margin-bottom: 0;
}
.body {
  padding: 0 40px;
}

.text-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  color: white;
  margin-right: 40px;
}
.btn-sm {
  padding: 8px 14px;
  line-height: 16px;
  font-size: 11px;
}
.card-shipping-wise {
  border-radius: 5px;
  -webkit-box-shadow: 0 0 5px 0 rgba(43, 43, 43, 0.1),
    0 11px 6px -7px rgba(43, 43, 43, 0.1);
  box-shadow: 0 0 5px 0 rgba(43, 43, 43, 0.1),
    0 11px 6px -7px rgba(43, 43, 43, 0.1);
  border: none;
  margin-bottom: 30px;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  padding: 20px;
  height: 140px;
}
.card-wise-dashboard {
  background-color: white;
  margin: 0;
  width: 25rem;
  max-width: 230px;
}
.card-wise-header {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}
.card-dashboard-wise {
  background: white;
  flex: 0 0 calc((100% - 40px) / 3);
  max-width: calc((100% - 40px) / 3);
}
.open-btn {
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-container {
  background: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  text-align: center;
  max-width: 600px;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

.close-btn {
  margin-top: 10px;
  padding: 8px 15px;
  cursor: pointer;
}
.text-c-info {
  color: #00bcd4;
}
</style>
